// constants
import { showSuccessAlert } from "../../constants/alerts";
import { UserActionTypes } from "./constants";

const INIT_STATE = {
  users: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface UserActionType {
  type:
    | UserActionTypes.API_RESPONSE_SUCCESS
    | UserActionTypes.API_RESPONSE_ERROR
    | UserActionTypes.GET_USER_DATA
    | UserActionTypes.BLOCK_USER
    | UserActionTypes.ACTIVATE_USER;

  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    message?: string;
  };
}

const Users = (state: any = INIT_STATE, action: UserActionType): any => {
  switch (action.type) {
    case UserActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case UserActionTypes.GET_USER_DATA: {
          return {
            ...state,
            users: action.payload.data.users,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case UserActionTypes.BLOCK_USER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        case UserActionTypes.ACTIVATE_USER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        default:
          return { ...state };
      }

    case UserActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case UserActionTypes.GET_USER_DATA: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case UserActionTypes.BLOCK_USER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case UserActionTypes.ACTIVATE_USER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }

        default:
          return { ...state };
      }

    case UserActionTypes.GET_USER_DATA:
      return { ...state, loading: true, initialLoading: true };
    case UserActionTypes.ACTIVATE_USER:
      return { ...state, loading: true, initialLoading: true };
    case UserActionTypes.BLOCK_USER:
      return { ...state, loading: true, initialLoading: true };

    default:
      return { ...state };
  }
};

export default Users;
